import { OptionsMostFrequent, OptionsMostFrequentArray } from "../../questionarie/response";

export const formatFrequentOptions = ({ response }: { response: OptionsMostFrequentArray }) => {

    const options: OptionsMostFrequent[] = response.map(option => ({

        areaId: option.areaId,
        departmentId: option.departmentId,
        areaName: option.areaName,
        departmentName: option.departmentName,
        category_id: option.category_id,
        category: option.category,
        subcategoryId: option.subcategoryId,
        subcategory: option.subcategory,
        amountFolios: option.amountFolios,
        priorityId: option.priorityId,
        userAssigned: option.userAssigned,
        categories: option.categories,
        fullNameUserAssing: option.fullNameUserAssing
    }));

    return {
        options
    }
}